import {ExpressionElement} from '@packages/systems/wfdl-ast';
import {isDivBlock} from '@packages/utilities/elementTypeUtils';
import {getTagFromData} from '@packages/utilities/platform';

// A Box rendering a `section` tag is treated as functionally equivalent to a legacy Section.
export function isBoxSection(element: ExpressionElement): boolean {
  return isDivBlock(element) && getTagFromData(element) === 'section';
}
